module.exports = __webpack_public_path__ + "assets/img/hotAir_on.315f7371.png";